export default __webpack_public_path__ + "static/media/ant.550a54f5.png";